import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
          light: '#8EDCB9',
          main: '#69D0A3',
          dark: '#53CA98',
        },
        secondary: {
          light: '#FF7C70',
          main: '#FF6961',
        },
        terciary:{
          main: '#FFF7EA'
        },
        quaternary:{
          main: '#2196F3',
          light: '#81C9FA'
        }
    },
    typography: {
      fontFamily: 'Roboto-Regular'
    }
});

export default theme